import axios from 'axios';
import moment from 'moment';
import settings from '../constants/constants';

const API_URL = `${settings.url}/orders`;

const placeOrderFromCart = (postObj, orderLimit=100) => {
  return axios.post(`${API_URL}`, {
    order_tz: moment().format('Z'),
    orderLimit: orderLimit,
    ...postObj,
  });
};

const getOrderSuccessInfo = (body) => {
  return axios.post(`${API_URL}/success`, body);
};

const updateBackOrder = (backOrderId, quantity) =>{
  return axios.put(`${API_URL}/back-orders?`, {
    backOrderId,
    quantity,
    update_tz: moment().format('Z')
  });
};

const getOrderSummary = () => {
  return axios.get(`${API_URL}/summary`);
};

const updateOrderItem = (orderItemId, quantity, confirmed = false, pharmacistID = null, orderTag = null, pharmacyName = null) => {
  return axios.put(`${settings.url}/orders`, {
    orderItemId,
    quantity,
    ...(confirmed && { confirmed: true }),
    pharmacistID,
    pharmacyName,
    orderTag
  });
};

const syncOrderStatus = () => {
  return axios.get(`${settings.url}/orders/sync`);
};

const getOrderStatus = () => {
  return axios.get(`${settings.url}/orders/status`);
};

const deleteBackOrder = (backOrderIds) => {
  return axios.delete(`${API_URL}/back-orders/${backOrderIds}`);
};

const deleteOrderItem = (orderItemId) => {
  return axios.delete(`${API_URL}/${orderItemId}`);
};

const updateOrderApproval = (orderItemIds, isApproved, isResubmitted) => {
  return axios.put(`${API_URL}/status`, { orderItemIds, isApproved, isResubmitted });
};

export {
  placeOrderFromCart,
  getOrderSuccessInfo,
  getOrderSummary,
  updateOrderItem,
  updateBackOrder,
  syncOrderStatus,
  getOrderStatus,
  deleteBackOrder,
  deleteOrderItem,
  updateOrderApproval
};
